module.exports = __webpack_public_path__ + "img/IMG019.ea66e69a.jpg";